/*eslint-disable*/
import {
	Icon,
	IconButton,
	LinearProgress,
	Paper,
	Popover,
	Table,
	TableBody,
	TableCell,
	TableRow,
	Typography
} from '@material-ui/core';
import EnhancedTableHead from 'components/EnhancedTableHead/EnhancedTableHead.jsx';
import Button from "@material-ui/core//Button";
import Grid from "@material-ui/core/Grid";
import MobileStepper from "@material-ui/core/MobileStepper";
import GridItem from "components/Grid/GridItem.jsx";
import gql from "graphql-tag";
import TaxCalculator from "helpers/TaxCalculator";
import { GetUserToken } from "helpers/UserHelper";
import moment from "moment";
import { ClientById } from "queries/clientById";
import { getClientsByBroker } from "queries/clientsByBroker";
import React, { Component } from "react";
import { graphql, Query } from "react-apollo";
import { connect } from "react-redux";
import { successWarning, showSnack } from "reducers/NotificationReducer";
import { change, reduxForm, reset, untouch } from "redux-form";
import store from "store";
import PopulateClient from "../helpers/PopulateClient";
import CC_bankDetail from "./CC_bankDetail.jsx";
import CC_clientForm from "./CC_clientForm.jsx";
import CC_clientOccForm from "./CC_clientOccForm.jsx";
import CC_contactDetails from "./CC_contactDetails.jsx";
import CC_healthInfo from "./CC_healthInfo.jsx";
import CC_willDetail from "./CC_willDetail.jsx";
import { imageTypes, validateFile } from "helpers/Documents.js";
import { fileUploadServerPath } from "constants.js";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";
import { ParseDMYwSlashes } from "helpers/DateHelpers";
import _ from "lodash";
import { ParseUriParams } from "helpers/UriReader";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import CC_clientForm_EliteWealth from "./CC_clientForm_EliteWealth";
import CC_clientOccForm_EliteWealth from "./CC_clientOccForm_EliteWealth";
import QuotesTab_EliteWealth from "../ClientDetail/tabs/quotes/QuotesTab_EliteWealth.jsx";
import { Mutation } from 'react-apollo';
import { QuoteEligibility } from 'queries/QuoteEligibility';
import CustomChip from 'components/CustomChip/CustomChip.jsx';
import SweetAlert from 'react-bootstrap-sweetalert';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import withStyles from '@material-ui/core/styles/withStyles';

import BaseTablePageContent from "./BaseTablePageContent";
import ManageClients from "./ManageClients_elite"

const tabStyle = {
  color: "white",
  borderBottom: "2px solid",
  opacity: "1"
};

const columnData = [
	{
		id: 'edit',
		numeric: false,
		disablePadding: true,
		label: '',
		noSort: true,
		width: '30px'
	},
	{
		id: 'description',
		numeric: false,
		disablePadding: true,
		label: 'Description',
		noSort: true
	},
	{
		id: 't.date_created',
		numeric: false,
		disablePadding: true,
		label: 'Date Created',
		noSort: true
	}
];


const tabs = ["Basic", "Contact", "Occupation", "Bank", "Health", "Will"];

const uploadClient = new ApolloClient({
  link: createUploadLink({ uri: fileUploadServerPath }),
  cache: new InMemoryCache()
});

const uploadFileMutation = gql`
  mutation($file: Upload!, $id: String!) {
    uploadClientAvatar(file: $file, id: $id)
  }
`;

const updateClient = gql`
  mutation updateClient($input: UpdateClientInput!) {
    UpdateClient(input: $input) {
      clientMutationId
      client {
        id
        scd_name
        scd_surname
        scd_email
        date_created
        scd_clientType
        scd_registered
        invite_sent
        app_info_complete
        status
      }
    }
  }
`;

const form = "client";

class ClientEditForm_EliteWealth extends Component {
  state = {
    page: 0,
    pageCount: 6,
    checkValidation: true,
    formInitiazed: false,
    firstName: "",
    secondName: "",
    lastName: "",
    afterTaxIncome: "0",
    age: 0,
    married: false,
    saCitizen: true,
    file: null,
    imgSrc: null,
    initialId: "",
    occupationValid: true,
    clientId: null,
    openMenus: [],
		openMenusPage: 0,
		anchorTop: 0,
		anchorLeft: 0,
		popoverOpen: false,
		assistantActive: false,
		eligibilityDialogOpen: false,
		invalidFields: [],
		selectedClient: {},
    selected: false
  };

  componentDidMount() {
    const params = ParseUriParams(this.props.location.search);
    const { clientId } = params;
    this.setState({ clientId: clientId });
  }

  toggleOccupationValid = valid => {
    this.setState({ occupationValid: valid });
  };

  submit = () => {
    if (this.state.page === 0 && !this.state.occupationValid) {
      store.dispatch(
        showSnack({
          message: "Invalid Occupation",
          color: "danger"
        })
      );
      return;
    }
    
    if (store.getState().form.client.syncErrors) {
      store.dispatch(
        showSnack({
          message: "Invalid Information",
          color: "danger"
        })
      );
      this.setState({ checkValidation: true });
      this.forceUpdate();
    } else if (this.checkOccupationDuties()) {
      store.dispatch(
        showSnack({
          message: "Occupational Duties must add up to 100%",
          color: "danger"
        })
      );
    } else {
      this.setState({ checkValidation: false });

      var dat = store.getState().form.client.values;
      dat.calculatedMonthlyIncomeAT = this.state.afterTaxIncome;
      dat.actualMonthlyIncomeAT = this.state.afterTaxIncome;

      var input = {
        clientId: this.state.clientId,
        data: dat,
        token: GetUserToken()
      };

      this.props
        .mutate({
          variables: {
            input
          }
        })
        .then(resp => {
          store.dispatch(
            successWarning({
              open: true,
              title: "Client Updated.",
              onConfirm: () => 
              {
                var url = '/app/quote?'+ window.location.href.substring(window.location.href.indexOf("?") + 1);
                this.props.history.push(url)
              }
            })
          );

          if (this.state.file !== null) {
            uploadClient
              .mutate({
                mutation: uploadFileMutation,
                variables: {
                  file: this.state.file,
                  id: this.state.clientId
                }
              })
              .then(console.log("profile picture updated"));
          }
        })
        .catch(error => {
          store.dispatch(
            showSnack({
              message: "There was an error updating this client : " + error,
              color: "danger"
            })
          );
        });
    }
  };

  submitClient = (itm) => {
    if (this.state.page === 0 && !this.state.occupationValid) 
    {
      store.dispatch(
        showSnack({
          message: "Invalid Occupation",
          color: "danger"
        })
      );
      return;
    }
    if ((!sessionStorage.getItem("ActiveBrokerId") || sessionStorage.getItem("ActiveBrokerId") == 0 ) && localStorage.getItem("userType") == 6) {
      store.dispatch(
        showSnack({
          message: "Please select a broker.",
          color: "danger"
        })
      );
      return;
    }
    if (store.getState().form.client.syncErrors) {
      store.dispatch(
        showSnack({
          message: "Invalid Information",
          color: "danger"
        })
      );
      this.setState({ checkValidation: true });
      this.forceUpdate();
    } else if (this.checkOccupationDuties()) {
      store.dispatch(
        showSnack({
          message: "Occupational Duties must add up to 100%",
          color: "danger"
        })
      );
    } else {
      this.setState({ checkValidation: false });

      var dat = store.getState().form.client.values;
      dat.calculatedMonthlyIncomeAT = this.state.afterTaxIncome;
      dat.actualMonthlyIncomeAT = this.state.afterTaxIncome;

      var input = {
        clientId: this.state.clientId,
        data: dat,
        token: GetUserToken()
      };

      this.props
        .mutate({
          variables: {
            input
          }
        })
        .then(resp => {
          store.dispatch(
            successWarning({
              open: true,
              title: "Client Updated.",
              onConfirm: () => 
              {
                itm();
              }
            })
          );

          if (this.state.file !== null) {
            uploadClient
              .mutate({
                mutation: uploadFileMutation,
                variables: {
                  file: this.state.file,
                  id: this.state.clientId
                }
              })
              .then(console.log("profile picture updated"));
          }
        })
        .catch(error => {
          store.dispatch(
            showSnack({
              message: "There was an error updating this client : " + error,
              color: "danger"
            })
          );
        });
    }
  };

  handleSelect = broker => {
    
    sessionStorage.setItem("ActiveBrokerId", broker.su_ID);
    sessionStorage.setItem(
      "ActiveBrokerName",
      broker.su_name + " " + broker.su_surname
    );
    this.setState({selected: !this.props.selected});
  };

  initializeForm(data) {
    this.setState({
      firstName: data.scd_name ? data.scd_name : "",
      lastName: data.scd_surname ? data.scd_surname : ""
    });

    let populatedClient = PopulateClient(data);

    this.props.initialize({
      ...populatedClient
    });

    if (data.scd_maritalStatus && data.scd_maritalStatus === "Married") {
      this.setState({ married: true });
    }

    if (data.scd_idType && data.scd_idType === "passport") {
      this.setState({ saCitizen: false });
    }

    if (data.scd_pp_path) {
      this.setState({ imgSrc: data.scd_pp_path });
    }

    if (data.scd_dateOfBirth) {
      this.dobChanged(data.scd_dateOfBirth.split("T")[0]);
    }

    if (data.scd_monthlyIncome) {
      this.onSalaryChange(parseFloat(data.scd_monthlyIncome));
    }

    this.setState({
      formInitiazed: true,
      initialId: data.scd_saID ? data.scd_saID : ""
    });
  }

  componentWillUnmount() {
    store.dispatch(reset("client"));
    store.dispatch(
      showSnack({
        open: false
      })
    );
  }

  changeFirstName(name) {
    if (name && name !== "") {
      let initials = "";
      initials = name.substring(0, 1) + this.state.secondName.substring(0, 1);

      store.dispatch(change("client", "initials", initials));
      this.setState({ firstName: name });
    }
  }

  changeSecondName(name) {
    if (name && name !== "") {
      let initials = "";
      initials = this.state.firstName.substring(0, 1) + name.substring(0, 1);

      store.dispatch(change("client", "initials", initials));
      this.setState({ secondName: name });
    }
  }

  changeLastName(name) {
    this.setState({ lastName: name });
  }

  checkOccupationDuties = () => {
    var clientForm = store.getState().form.client.values;
    if (
      
      parseInt(clientForm.Admin) +
        parseInt(clientForm.Travel) +
        parseInt(clientForm.ManualLabour) +
        parseInt(clientForm.Supervision) !==
        100
    ) {
      return true;
    }
    return false;
  };

  nextPage = () => {
    if (this.state.page === 2 && !this.state.occupationValid) {
      store.dispatch(
        showSnack({
          message: "Invalid Occupation",
          color: "danger"
        })
      );
      return;
    }
    if ((!sessionStorage.getItem("ActiveBrokerId") || sessionStorage.getItem("ActiveBrokerId") == 0 ) && localStorage.getItem("userType") == 6) {
      store.dispatch(
        showSnack({
          message: "Please select a broker.",
          color: "danger"
        })
      );
      return;
    }
    if (this.checkOccupationDuties()) {
      store.dispatch(
        showSnack({
          message: "Occupational Duties must add up to 100%",
          color: "danger"
        })
      );
    } else {
      if (store.getState().form.client.syncErrors) {
        store.dispatch(
          showSnack({
            message: "Invalid Information",
            color: "danger"
          })
        );
        this.setState({ checkValidation: true });
        this.forceUpdate();
      } else {
        this.setState({ page: this.state.page + 1, checkValidation: false });
        this.forceUpdate();
        this.props.scrollMeBar();
      }
    }
  };

  previousPage = () => {
    if (this.state.page === 0 && !this.state.occupationValid) {
      store.dispatch(
        showSnack({
          message: "Invalid Occupation",
          color: "danger"
        })
      );
      return;
    }
    this.setState({ page: this.state.page - 1 });
    this.props.scrollMeBar();
  };

  onSalaryChange(value) {
    value = value
      .toString()
      .replace(/,/g, "")
      .replace(/ /g, "");
    if (value === "" || isNaN(Number(value))) {
      return;
    }
    var x = TaxCalculator(
      parseFloat(value),
      _.get(store.getState().form, "client.values.age", null)
    );

    x = x.toString();

    //let parsed = parseFloat(val);

    this.setState({ afterTaxIncome: x.toString() });
    this.forceUpdate();

    if (
      store.getState().form.client.fields &&
      store.getState().form.client.fields.actualMonthlyIncomeAT &&
      store.getState().form.client.fields.actualMonthlyIncomeAT.touched
    ) {
      return;
    } else {
      store.dispatch(change("client", "actualMonthlyIncomeAT", x.toString()));
      store.dispatch(untouch("client", "actualMonthlyIncomeAT"));
    }
  }

  dobChanged = val => {
    try {
      if (val.length !== 10) throw "Too short";
      var dob = ParseDMYwSlashes(val);
      var age = moment().diff(dob, "years");
      store.dispatch(change("client", "age", age));
    } catch (error) {
      store.dispatch(change("client", "age", ""));
    }
    this.forceUpdate();
  };

  maritalChangeHandler = value => {
    if (value === "Married") {
      this.setState({ married: true });
      if (store.getState().form.client.values.title === "MISS") {
        store.dispatch(change("client", "title", "MRS"));
      }
    } else {
      if (value !== "validationError") {
        if (store.getState().form.client.values.title === "MRS") {
          store.dispatch(change("client", "title", "MISS"));
        }
      }
      store.dispatch(change("client", "spouseIncome", ""));
      this.setState({ married: false });
    }
  };

  resetclientIdDetails() {
    store.dispatch(change("client", "said", ""));
    store.dispatch(untouch("client", "said"));

    store.dispatch(change("client", "passportNumber", ""));
    store.dispatch(untouch("client", "passportNumber"));
  }

  idChangeHandler = value => {
    if (value === "idNumber") {
      if (!this.state.saCitizen) {
        this.resetclientIdDetails();
      }
      this.setState({ saCitizen: true });
    } else {
      if (this.state.saCitizen) {
        this.resetclientIdDetails();
      }
      this.setState({ saCitizen: false });
    }
  };

  withoutClasses(props) {
    let newProps = { ...props };
    delete newProps.classes;
    return newProps;
  }

  fileAttached = file => {
    var valid = validateFile(file.name, imageTypes);
    if (!valid) {
      store.dispatch(
        showSnack({
          message: "Invalid file type.",
          color: "danger"
        })
      );
    } else {
      this.setState({ file: file, imgSrc: URL.createObjectURL(file) });
    }
  };

  handleChangeTab = (event, value) => {
    if (value == 0) return;
    this.setState({ page: value - 1 });
  };

  handleNewQuote = clientId => {
		this.props.history.push({
			pathname: '/app/quote/',
			search: `clientId=${clientId}`
		});
	};

  render() {
    const { page } = this.state;
    const params = ParseUriParams(this.props.location.search);
    const { clientId } = params;

    return (
      <Query
        query={ClientById}
        variables={{
          id: clientId,
          token: GetUserToken()
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data }) => {
          if (loading)
            return (
              <div>
                <LinearProgress />
              </div>
            );
          if (error) return `Error! ${error.message}`;

          if (!this.state.formInitiazed) {
            this.initializeForm(data.ClientById[0]);
          }

          

          return (
            <Grid container>
            
              <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
                <div className={"fixedStepper"}>
                  <Grid container>
                    <GridItem
                      xs={12}
                      sm={12}
                      md={10}
                      style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}
                    >
                      <div
                        className={"stepperDiv"}
                        style={{ position: "relative" }}
                      >
                      
                        <AppBar position="static" color="primary">
                        
                          <Tabs
                            tab={page}
                            onChange={this.handleChangeTab}
                            scrollable
                            scrollButtons="on"
                            classes={{ scrollButtons: "scrollButton" }}
                          >
                            
                          
                           
                              <Mutation
                                mutation={QuoteEligibility}
                                onCompleted={data => {
                                  var quoteEligibility = data.QuoteEligibility;
                                  if (!quoteEligibility.valid) {
                                    let invalidFields = quoteEligibility.invalidFields.split(
                                      ','
                                    );
                                    this.setState({
                                      eligibilityDialogOpen: true,
                                      invalidFields: invalidFields,
                                      selectedClient: this.props.clientName
                                    });
                                  } else {
                                    this.handleNewQuote(clientId);
                                  }
                                }}
                              >
                                {mutate => (
                                  <Tab
                                  className="saveTab"
                                  label={<strong>SAVE & Create New Quote </strong> }
                                    onClick=
                                    {() =>
                                      this.submitClient(() =>
                                      mutate(
                                      {
                                        variables: {
                                          input: {
                                            clientId: clientId
                                          }
                                        }
                                      }))
                                    }
                                    
                                  />
                                )}
                              </Mutation>

                              
                              {this.state.eligibilityDialogOpen ? (
                                <SweetAlert
                                  warning
                                  style={{ wordWrap: 'break-word', top: '40%' }}
                                  title={'Ineligible'}
                                  
                                  confirmBtnCssClass={
                                    this.props.classes.button + ' ' + this.props.classes.success
                                  }
                                  cancelBtnCssClass={
                                    this.props.classes.button + ' ' + this.props.classes.danger
                                  }
                                  confirmBtnText="Save"
                                  cancelBtnText="Close"
                                  onConfirm={() => {
                                    this.submitClient();
                                    this.setState({
                                      eligibilityDialogOpen: false
                                    });
                                  }}
                                  onCancel={() => {
                                    this.setState({
                                      eligibilityDialogOpen: false
                                    });
                                  }}
                                  showCancel={true}
                                  showConfirm={false}
                                >
                                  <Typography>
                                    {this.state.selectedClient}
                                    is ineligible for a quote.
                                  </Typography>
                                  <br />
                                  <Typography>Please update the following fields: </Typography>
                                  <Grid container className="invalidListBlock">
                                    {this.state.invalidFields.map(i => {
                                      return (
                                        <Grid item xs={12} sm={6} md={6}>
                                          <Typography>{i}</Typography>
                                        </Grid>
                                      );
                                    })}
                                  </Grid>
                                </SweetAlert>
                              ) : null}
                           
					
					
                          </Tabs>
                        </AppBar>
                      </div>
                    </GridItem>
                  </Grid>
                </div>
                <br />
                {page === 0 && localStorage.getItem("userType") == "6" && (
                  <ManageClients
                  handleSelect = {this.handleSelect.bind(this)}
                    {...this.withoutClasses(this.props)}
                    {...this.state}
                  />
                )}
                {page === 0 && (
                  <CC_clientForm_EliteWealth
                    changeFirstName={this.changeFirstName.bind(this)}
                    changeLastName={this.changeLastName.bind(this)}
                    changeSecondName={this.changeSecondName.bind(this)}
                    dobChanged={this.dobChanged}
                    idChangeHandler={this.idChangeHandler.bind(this)}
                    maritalChangeHandler={this.maritalChangeHandler.bind(this)}
                    editMode={true}
                    uploadMutation={uploadFileMutation}
                    fileAttached={this.fileAttached}
                    salaryChangeHandler={this.onSalaryChange.bind(this)}
                    toggleOccupationValid={this.toggleOccupationValid}
                    {...this.withoutClasses(this.props)}
                    {...this.state}
                  />
                )}
                {page === 0 && (
                  <CC_clientOccForm_EliteWealth
                    salaryChangeHandler={this.onSalaryChange.bind(this)}
                    toggleOccupationValid={this.toggleOccupationValid}
                    {...this.withoutClasses(this.props)}
                    {...this.state}
                  />
                )}
              </GridItem>
                  {!((!sessionStorage.getItem("ActiveBrokerId") || sessionStorage.getItem("ActiveBrokerId") == 0 ) && localStorage.getItem("userType") == 6) &&
                  (
                    <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
                    <QuotesTab_EliteWealth
                    clientId={clientId}
                    />
                    </GridItem>
                  )}
              

            </Grid>
          );
        }}
      </Query>
    );
  }
}

ClientEditForm_EliteWealth = reduxForm({
  form: form,
  destroyOnUnmount: true
})(ClientEditForm_EliteWealth);

ClientEditForm_EliteWealth = connect(() => ({}))(ClientEditForm_EliteWealth);

ClientEditForm_EliteWealth = graphql(updateClient, {
  options: {
    update: (proxy, { data: { updateClient } }) => {
      const { clients } = proxy.readQuery({ query: getClientsByBroker });

      var targetClientIndex = clients.findIndex(
        c => c.id === updateClient.client.id
      );
      clients[targetClientIndex] = updateClient.client;

      proxy.writeQuery({
        getClientsByBroker,
        data: clients
      });
    }
  }
})(ClientEditForm_EliteWealth);

export default withStyles(sweetAlertStyle)(ClientEditForm_EliteWealth);



// WEBPACK FOOTER //
// ./src/views/Clients/components/ClientEditForm_EliteWealth.jsx